/* True Of Blue — Landing PDP behaviours. No dependencies. */
(function () {
  'use strict';

  /* LP-GUARD-START
     Every sections/lp-*.liquid emits its own <script src="lp-pdp.js">, so on a
     landing template this file executes ~16 times. That double-bound every click
     handler (an unforced classList.toggle run an even number of times is a no-op,
     which is why the accordions appeared dead) and started 16 copies of the
     countdown interval and the purchase-popup loop, which is what made the page
     lag. Only the first execution should do anything.
     LP-GUARD-END */
  if (window.__lpPdpInit) return;
  window.__lpPdpInit = true;

  var onReady = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ---------- Gallery: main track + thumbs + arrows ---------------------- */
  function initGallery(root) {
    var track = root.querySelector('.lp-gal__track');
    var slides = root.querySelectorAll('.lp-gal__slide');
    var thumbs = root.querySelectorAll('.lp-gal__thumb');
    if (!track || !slides.length) return;

    function goTo(i) {
      var slide = slides[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function markActive(i) {
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle('is-active', t === i);
    }

    for (var t = 0; t < thumbs.length; t++) {
      (function (idx) {
        thumbs[idx].addEventListener('click', function () { goTo(idx); markActive(idx); });
      })(t);
    }

    var prev = root.querySelector('.lp-gal__arrow--prev');
    var next = root.querySelector('.lp-gal__arrow--next');
    function current() {
      var best = 0, min = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < min) { min = d; best = i; }
      }
      return best;
    }
    if (prev) prev.addEventListener('click', function () {
      var i = Math.max(0, current() - 1); goTo(i); markActive(i);
    });
    if (next) next.addEventListener('click', function () {
      var i = Math.min(slides.length - 1, current() + 1); goTo(i); markActive(i);
    });

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { markActive(current()); });
    }, { passive: true });

    markActive(0);
  }

  /* ---------- Accordions ------------------------------------------------- */
  function initAccordions(scope) {
    var qs = scope.querySelectorAll('.lp-acc__q');
    for (var i = 0; i < qs.length; i++) {
      qs[i].addEventListener('click', function () {
        var item = this.closest('.lp-acc__item');
        if (!item) return;
        var list = item.parentNode;
        var single = list && list.getAttribute('data-single') === 'true';
        if (single && !item.classList.contains('is-open')) {
          var open = list.querySelectorAll('.lp-acc__item.is-open');
          for (var k = 0; k < open.length; k++) {
            open[k].classList.remove('is-open');
            var b = open[k].querySelector('.lp-acc__q');
            if (b) b.setAttribute('aria-expanded', 'false');
          }
        }
        var willOpen = !item.classList.contains('is-open');
        item.classList.toggle('is-open', willOpen);
        this.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    }
  }

  /* ---------- Ingredient tabs -------------------------------------------- */
  function initIngredients(root) {
    var items = root.querySelectorAll('.lp-ing__item');
    for (var i = 0; i < items.length; i++) {
      (function (idx) {
        items[idx].addEventListener('click', function () {
          var key = this.getAttribute('data-key');
          var all = root.querySelectorAll('.lp-ing__item');
          for (var a = 0; a < all.length; a++) all[a].classList.toggle('is-active', all[a] === items[idx]);
          var panels = root.querySelectorAll('.lp-ing__panel');
          for (var p = 0; p < panels.length; p++) panels[p].classList.toggle('is-active', panels[p].getAttribute('data-key') === key);
          var cards = root.querySelectorAll('.lp-ing__card');
          for (var c = 0; c < cards.length; c++) cards[c].classList.toggle('is-active', cards[c].getAttribute('data-key') === key);
        });
      })(i);
    }
  }

  /* ---------- Offer / purchase selectors --------------------------------- */
  function initSelectors(scope) {
    function group(sel, activeCls) {
      var rows = scope.querySelectorAll(sel);
      for (var i = 0; i < rows.length; i++) {
        rows[i].addEventListener('click', function () {
          var siblings = this.parentNode.querySelectorAll(sel);
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove(activeCls);
          this.classList.add(activeCls);
          var input = this.querySelector('input[type=radio]');
          if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      }
    }
    group('.lp-offer__row', 'is-active');
    group('.lp-purchase__opt', 'is-active');
    group('.lp-stack__card', 'is-active');
  }

  /* ---------- Countdown --------------------------------------------------- */
  function initCountdown(root) {
    var mins = parseInt(root.getAttribute('data-minutes') || '30', 10);
    var key = 'lp-countdown-' + (root.getAttribute('data-key') || 'default');
    var reset = root.getAttribute('data-reset') === 'true';
    var end;

    try {
      var stored = reset ? null : sessionStorage.getItem(key);
      end = stored ? parseInt(stored, 10) : 0;
      if (!end || end < Date.now()) {
        end = Date.now() + mins * 60000;
        if (!reset) sessionStorage.setItem(key, String(end));
      }
    } catch (e) { end = Date.now() + mins * 60000; }

    var hEl = root.querySelector('[data-h]'), mEl = root.querySelector('[data-m]'), sEl = root.querySelector('[data-s]');
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var left = Math.max(0, end - Date.now());
      var totalSec = Math.floor(left / 1000);
      if (hEl) hEl.textContent = pad(Math.floor(totalSec / 3600));
      if (mEl) mEl.textContent = pad(Math.floor((totalSec % 3600) / 60));
      if (sEl) sEl.textContent = pad(totalSec % 60);
      if (left <= 0) {
        end = Date.now() + mins * 60000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) {}
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Sticky bar --------------------------------------------------- */
  function initSticky(bar) {
    var afterSel = bar.getAttribute('data-show-after');
    var anchor = afterSel ? document.querySelector(afterSel) : null;
    function update() {
      var threshold = anchor ? (anchor.getBoundingClientRect().bottom < 0) : (window.scrollY > 700);
      bar.classList.toggle('is-visible', threshold);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Purchase popup ---------------------------------------------- */
  function initPopup(pop) {
    var names = (pop.getAttribute('data-names') || '').split('|').filter(Boolean);
    var places = (pop.getAttribute('data-places') || '').split('|').filter(Boolean);
    var minAgo = parseInt(pop.getAttribute('data-min-ago') || '2', 10);
    var maxAgo = parseInt(pop.getAttribute('data-max-ago') || '25', 10);
    var first = parseInt(pop.getAttribute('data-first-delay') || '9', 10) * 1000;
    var gap = parseInt(pop.getAttribute('data-gap') || '22', 10) * 1000;
    var visible = parseInt(pop.getAttribute('data-visible') || '6', 10) * 1000;
    if (!names.length) return;

    var whoEl = pop.querySelector('.lp-pop__who');
    var timeEl = pop.querySelector('[data-ago]');
    var closeBtn = pop.querySelector('.lp-pop__close');
    var stopped = false;
    var i = 0;

    if (closeBtn) closeBtn.addEventListener('click', function () {
      stopped = true; pop.classList.remove('is-visible');
    });

    function rand(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }

    function show() {
      if (stopped) return;
      var name = names[i % names.length];
      var place = places.length ? places[rand(0, places.length - 1)] : '';
      if (whoEl) whoEl.innerHTML = '<b>' + name + '</b>' + (place ? ' in ' + place : '') + ' purchased';
      if (timeEl) timeEl.textContent = rand(minAgo, maxAgo) + 'm ago';
      i++;
      pop.classList.add('is-visible');
      setTimeout(function () {
        pop.classList.remove('is-visible');
        if (!stopped) setTimeout(show, gap);
      }, visible);
    }
    setTimeout(show, first);
  }

  /* ---------- Horizontal drag-to-scroll for card tracks -------------------- */
  function initDrag(track) {
    var down = false, startX = 0, startScroll = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; startX = e.clientX; startScroll = track.scrollLeft;
    });
    window.addEventListener('pointerup', function () { down = false; });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      e.preventDefault();
      track.scrollLeft = startScroll - (e.clientX - startX);
    });
  }

  /* ---------- Before / after tabs ------------------------------------------ */
  function initBaTabs(root) {
    var tabs = root.querySelectorAll('[data-ba-tab]');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function () {
        var key = this.getAttribute('data-ba-tab');
        var all = root.querySelectorAll('[data-ba-tab]');
        for (var a = 0; a < all.length; a++) all[a].classList.toggle('is-active', all[a] === this);
        var panels = root.querySelectorAll('[data-ba-panel]');
        for (var p = 0; p < panels.length; p++) panels[p].classList.toggle('is-active', panels[p].getAttribute('data-ba-panel') === key);
      });
    }
  }

  /* ---------- Email capture popup ------------------------------------------ */
  function initEmailPop(pop) {
    var key = pop.getAttribute('data-key') || 'lp-emailpop';
    var delay = parseInt(pop.getAttribute('data-delay') || '20', 10) * 1000;
    try { if (sessionStorage.getItem(key) === 'seen') return; } catch (e) {}

    function close() {
      pop.classList.remove('is-open');
      try { sessionStorage.setItem(key, 'seen'); } catch (e) {}
    }
    var closers = pop.querySelectorAll('[data-emailpop-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    setTimeout(function () { pop.classList.add('is-open'); }, delay);
  }

  /* ---------- Generic modals ----------------------------------------------- */
  function initModals(scope) {
    var opens = scope.querySelectorAll('[data-lp-modal-open]');
    for (var i = 0; i < opens.length; i++) {
      opens[i].addEventListener('click', function () {
        var t = document.getElementById(this.getAttribute('data-lp-modal-open'));
        if (t) t.classList.add('is-open');
      });
    }
    var closes = scope.querySelectorAll('[data-lp-modal-close]');
    for (var c = 0; c < closes.length; c++) {
      closes[c].addEventListener('click', function () {
        var m = this.closest('.lp-modal');
        if (m) m.classList.remove('is-open');
      });
    }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('.lp-modal.is-open');
    for (var i = 0; i < open.length; i++) open[i].classList.remove('is-open');
  });

  /* ---------- Generic slider: arrows + dots -------------------------------- */
  function initSlider(root) {
    var track = root.querySelector('.lp-slider__track');
    var slides = root.querySelectorAll('.lp-slider__slide');
    if (!track || slides.length < 2) return;
    var dotsWrap = root.querySelector('.lp-slider__dots');
    if (dotsWrap && !dotsWrap.children.length) {
      for (var i = 0; i < slides.length; i++) {
        var d = document.createElement('span');
        d.className = 'lp-slider__dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(d);
      }
    }
    function current() {
      var best = 0, min = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < min) { min = d; best = i; }
      }
      return best;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function mark() {
      if (!dotsWrap) return;
      var c = current();
      for (var i = 0; i < dotsWrap.children.length; i++) dotsWrap.children[i].classList.toggle('is-active', i === c);
    }
    var prev = root.querySelector('.lp-slider__btn--prev');
    var next = root.querySelector('.lp-slider__btn--next');
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
  }

  /* ---------- Tab bars (lp-tabs and toggles) -------------------------------- */
  function initTabBars(scope) {
    var tabs = scope.querySelectorAll('[data-lp-tab]');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function () {
        var group = this.closest('[data-lp-tabgroup]') || document;
        var key = this.getAttribute('data-lp-tab');
        var all = group.querySelectorAll('[data-lp-tab]');
        for (var a = 0; a < all.length; a++) all[a].classList.toggle('is-active', all[a] === this);
        var panels = group.querySelectorAll('[data-lp-panel]');
        for (var p = 0; p < panels.length; p++) panels[p].classList.toggle('is-active', panels[p].getAttribute('data-lp-panel') === key);
      });
    }
  }

  /* ---------- Simple open/close items (facc, natural cards) ----------------- */
  function initOpeners(scope) {
    var qs = scope.querySelectorAll('.lp-facc__q, .lp-na__q');
    for (var i = 0; i < qs.length; i++) {
      qs[i].addEventListener('click', function () {
        var item = this.closest('.lp-facc__item, .lp-na__item');
        if (item) item.classList.toggle('is-open');
      });
    }
  }

  /* ---------- Video play ---------------------------------------------------- */
  function initVideo(scope) {
    var plays = scope.querySelectorAll('.lp-vid__play');
    for (var i = 0; i < plays.length; i++) {
      plays[i].addEventListener('click', function () {
        var v = this.parentNode.querySelector('video');
        if (v) { v.play(); this.style.display = 'none'; }
      });
    }
  }

  function boot(scope) {
    scope = scope || document;
    var g = scope.querySelectorAll('.lp-gal');       for (var a = 0; a < g.length; a++) initGallery(g[a]);
    var ing = scope.querySelectorAll('.lp-ing');     for (var b = 0; b < ing.length; b++) initIngredients(ing[b]);
    var cd = scope.querySelectorAll('[data-countdown]'); for (var c = 0; c < cd.length; c++) initCountdown(cd[c]);
    var sb = scope.querySelectorAll('.lp-sticky');   for (var d = 0; d < sb.length; d++) initSticky(sb[d]);
    var pp = scope.querySelectorAll('.lp-pop');      for (var e = 0; e < pp.length; e++) initPopup(pp[e]);
    var tr = scope.querySelectorAll('.lp-cols__track,.lp-rev__track'); for (var f = 0; f < tr.length; f++) initDrag(tr[f]);
    var ba = scope.querySelectorAll('.lp-ba');       for (var h = 0; h < ba.length; h++) initBaTabs(ba[h]);
    var ep = scope.querySelectorAll('[data-emailpop]'); for (var k = 0; k < ep.length; k++) initEmailPop(ep[k]);
    var sl = scope.querySelectorAll('.lp-slider'); for (var g2 = 0; g2 < sl.length; g2++) initSlider(sl[g2]);
    initTabBars(scope);
    initOpeners(scope);
    initVideo(scope);
    initModals(scope);
    initAccordions(scope);
    initSelectors(scope);
  }

  onReady(function () { boot(document); });

  /* Theme editor: re-init a section when it is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
